import {Component, inject, OnInit, signal} from '@angular/core';
import {Router} from '@angular/router';
import {EventService} from '../../../../shared/services/event.service';
import {AlertService} from '../../../../shared/services/alert.service';
import {Messages} from '../../../../shared/constants/messages';
import {Event} from '../../../../shared/model/event';
import {EventFormComponent} from '../event-form/event-form.component';
import {PermissionService} from '../../../../core/services/permission.service';
import {OrganizationService} from '../../../../shared/services/organization.service';
import {Organization} from '../../../../shared/model/organization';
import {OrgCapability, SystemPower} from '../../../../shared/model/permissions';
import {NavigationHistoryService} from '../../../../core/services/navigation-history.service';

@Component({
  selector: 'app-event-add',
  standalone: true,
  imports: [EventFormComponent],
  templateUrl: './event-add.component.html',
  styleUrl: './event-add.component.css'
})
export class EventAddComponent implements OnInit {
  private eventService: EventService = inject(EventService);
  private alertService: AlertService = inject(AlertService);
  private router: Router = inject(Router);
  private permissionService = inject(PermissionService);
  private organizationService = inject(OrganizationService);
  private navigationHistory = inject(NavigationHistoryService);

  protected availableOrganizations = signal<Organization[]>([]);

  ngOnInit(): void {
    this.loadOrganizations();
  }

  onSubmit(eventData: Partial<Event>) {
    const payload: Event = {
      ...eventData,
      startDate: eventData.startDate!,
      endDate: eventData.endDate
    } as Event;

    this.eventService.createEvent(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.alertService.showSuccess(Messages.EVENT_CREATED_SUCCESS);
          this.router.navigate(['/events/mine']);
        }
      },
      error: (err) => {
        if (!err?.error?.message) {
          this.alertService.showError(Messages.EVENT_SAVE_ERROR);
        }
      }
    });
  }

  onCancel() {
    this.navigationHistory.goBack(['/events']);
  }

  private loadOrganizations(): void {
    if (this.permissionService.hasSystemPower(SystemPower.MODERATOR)) {
      this.organizationService.getAllOrganizations().subscribe({
        next: (response) => {
          if (response.success && response.data) {
            this.availableOrganizations.set(response.data.filter((org) => org.organizationActive));
          }
        }
      });
      return;
    }
    this.availableOrganizations.set(this.permissionService.organizationsWithCapability(OrgCapability.ORG_EVENT_CREATE));
  }
}
